import { CookiesConsent } from "@story/story_cookies_consent";
import { onDocumentReady } from "@story/story_assets/utils";

class CookiesConsentHybrid extends CookiesConsent {
	load() {
		// Read cookies from the cookie - the default behavior.
		super.load();

		if (this.allowed !== null) {
			return;
		}

		const consentString = localStorage.getItem("consentMode");
		if (!consentString) {
			return;
		}

		const consent = JSON.parse(consentString);
		const granted = Object.keys(consent).filter(key => consent[key] == "granted");

		this.allowed = [];
		if (granted.includes("functionality_storage") || granted.includes("security_storage")) {
			this.allowed.push("necessary");
		}
		if (granted.includes("ad_storage") || granted.includes("ad_user_data")) {
			this.allowed.push("marketing");
		}
		if (granted.includes("analytics_storage")) {
			this.allowed.push("analytical");
		}
		if (granted.includes("ad_personalization") || granted.includes("personalization_storage")) {
			this.allowed.push("personalization");
		}
	}

	static getInstance() {
		if (!this.instance) {
			this.instance = new CookiesConsentHybrid();
		}
		return this.instance;
	}
}


let cookiesConsentDialogInstance = null;

class CookiesConsentDialog {

	constructor(templateUrl) {
		this.templateUrl = templateUrl;
		this.dialog = null;
	}

	async show() {
		this.close();

		const response = await fetch(this.templateUrl, { headers: { "X-Requested-With": "XMLHttpRequest" } });
		const content = await response.text();

		let dialog = document.createElement("div");
		dialog.classList.add("page-cookies-consent");
		dialog.innerHTML = content;

		this.dialog = dialog.firstChild;

		document.body.append(this.dialog);
	}

	close() {
		if (this.dialog) {
			this.dialog.remove();
			this.dialog = null;
		}
	}
}

document.addEventSelectorListener("click", ".cookies-consent-link", function(event, target) {
	event.preventDefault();

	if (!cookiesConsentDialogInstance) {
		cookiesConsentDialogInstance = new CookiesConsentDialog(target.getAttribute("href"));
		cookiesConsentDialogInstance.show();
	}
});

CookiesConsent.onClose = function(instance) {
	if (cookiesConsentDialogInstance) {
		cookiesConsentDialogInstance.close();
		cookiesConsentDialogInstance = null;
	}
}

//
// První návštěva webu vyvolá dialog se souhlasem s cookies.
//
CookiesConsent.onShow = function(instance) {
	// Show cookies consent dialog for the first time.
	onDocumentReady(function() {
		let element = document.querySelector(".cookies-consent-link");
		element.click();
	});
}

function onCookiesConsentReady(callback) {
	let instance = CookiesConsentHybrid.getInstance();
	if (instance.isDone()) {
		callback(instance.allowed);
	}

	document.addEventListener("cookiesconsent:change", function(event) {
		callback(event.detail.allowed, event.detail.changes);
	});
}

onCookiesConsentReady(function(allowed, changes) {
	const necessary = allowed.includes("necessary") || allowed.includes("all") || true; // Necessary is always granted.
	const analytical = allowed.includes("analytical") || allowed.includes("all");
	const marketing = allowed.includes("marketing") || allowed.includes("all");
	const personalization = allowed.includes("personalization") || allowed.includes("all");

	const consent = {
		"functionality_storage": necessary ? "granted" : "denied",
		"analytics_storage": analytical ? "granted" : "denied",
		"ad_storage": marketing ? "granted" : "denied",
		"ad_user_data": marketing ? "granted" : "denied",
		"ad_personalization": personalization ? "granted" : "denied",
		"personalization_storage": personalization ? "granted" : "denied",
		"security_storage": necessary ? "granted" : "denied",
	};

	gtag("consent", "update", consent);
	gtag("set", "ads_data_redaction", false); // ???

	localStorage.setItem("consentMode", JSON.stringify(consent));
});